var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGlobe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.001 512.001",
    style: {
      enableBackground: "new 0 0 512.001 512.001"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 193.5587,
    y1: 398.1237,
    x2: 569.8387,
    y2: 21.8437,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B3E800"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#98BC00"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 276.942,
    cy: 199.309,
    r: 194.409
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 166.9864,
    y1: 424.7014,
    x2: 628.9064,
    y2: -37.2286,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98BC00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E6D03"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_2_)"
    },
    d: "M412.613,99.292c-7.016-4.883-14.474-9.337-22.3-13.356 c-4.019-7.827-8.474-15.284-13.356-22.3c-26.36-37.88-61.879-58.741-100.015-58.741s-73.655,20.861-100.015,58.741 c-4.883,7.016-9.337,14.474-13.356,22.3c-7.827,4.019-15.284,8.474-22.3,13.356c-37.88,26.36-58.741,61.879-58.741,100.015 s20.861,73.655,58.741,100.015c7.016,4.882,14.474,9.337,22.3,13.356c4.019,7.827,8.474,15.284,13.356,22.3 c26.36,37.88,61.879,58.741,100.015,58.741s73.655-20.861,100.015-58.741c4.882-7.016,9.337-14.474,13.356-22.3 c7.827-4.019,15.284-8.474,22.3-13.356c37.88-26.36,58.741-61.879,58.741-100.015C471.354,161.17,450.493,125.652,412.613,99.292z  M370.504,292.868c-14.915,6.81-31.241,11.906-48.471,15.141c2.791-17.486,4.868-36.885,6.165-57.447 c20.562-1.296,39.961-3.374,57.447-6.164C382.41,261.627,377.313,277.953,370.504,292.868z M265.281,338.365 c3.868,0.163,7.754,0.254,11.661,0.254s7.792-0.091,11.661-0.254c-4.568,16.367-9.015,24.48-11.661,27.682 C274.298,362.844,269.849,354.731,265.281,338.365z M276.942,312.139c-5.935,0-11.819-0.211-17.639-0.619 c-3.169-17.745-5.527-38.047-6.985-59.739c8.102,0.236,16.322,0.358,24.624,0.358c8.302,0,16.523-0.122,24.624-0.358 c-1.46,21.693-3.816,41.993-6.985,59.739C288.761,311.928,282.877,312.139,276.942,312.139z M183.379,292.868 c-6.81-14.915-11.907-31.241-15.141-48.471c17.486,2.791,36.885,4.868,57.447,6.164c1.296,20.562,3.374,39.961,6.165,57.447 C214.62,304.774,198.295,299.677,183.379,292.868z M183.379,105.743c14.915-6.809,31.241-11.907,48.471-15.141 c-2.791,17.486-4.868,36.885-6.165,57.447c-20.562,1.296-39.961,3.374-57.447,6.165 C171.473,136.985,176.571,120.659,183.379,105.743z M288.602,60.247c-3.868-0.162-7.754-0.254-11.661-0.254 s-7.792,0.091-11.66,0.254c4.568-16.367,9.015-24.48,11.66-27.682C279.586,35.767,284.035,43.88,288.602,60.247z M276.942,86.472 c5.935,0,11.819,0.211,17.639,0.62c3.169,17.745,5.527,38.047,6.985,59.738c-8.102-0.236-16.322-0.358-24.624-0.358 c-8.302,0-16.523,0.122-24.624,0.358c1.46-21.693,3.817-41.993,6.985-59.738C265.123,86.683,271.007,86.472,276.942,86.472z  M370.504,105.743c6.81,14.915,11.906,31.241,15.141,48.471c-17.486-2.791-36.885-4.868-57.447-6.165 c-1.296-20.562-3.374-39.961-6.165-57.447C339.263,93.837,355.589,98.934,370.504,105.743z M389.776,199.305 c0,5.935-0.211,11.819-0.619,17.639c-17.745,3.169-38.047,5.527-59.738,6.985c0.236-8.102,0.358-16.322,0.358-24.624 c0-8.302-0.122-16.523-0.358-24.624c21.693,1.46,41.993,3.816,59.738,6.985C389.564,187.486,389.776,193.371,389.776,199.305z  M164.108,199.305c0-5.935,0.211-11.819,0.619-17.639c17.745-3.169,38.047-5.527,59.738-6.985 c-0.236,8.102-0.358,16.322-0.358,24.624c0,8.302,0.122,16.523,0.358,24.624c-21.693-1.46-41.993-3.817-59.738-6.985 C164.32,211.124,164.108,205.24,164.108,199.305z M250.587,199.305c0-8.738,0.146-17.4,0.419-25.935 c8.536-0.273,17.197-0.419,25.935-0.419c8.738,0,17.4,0.146,25.935,0.419c0.273,8.536,0.419,17.197,0.419,25.935 s-0.146,17.4-0.419,25.935c-8.536,0.273-17.197,0.419-25.935,0.419s-17.4-0.146-25.935-0.419 C250.733,216.705,250.587,208.044,250.587,199.305z M137.883,210.966c-16.367-4.568-24.48-9.015-27.682-11.66 c3.203-2.644,11.315-7.093,27.682-11.66c-0.162,3.868-0.254,7.754-0.254,11.66C137.629,203.212,137.721,207.098,137.883,210.966z  M416.001,187.646c16.367,4.568,24.48,9.015,27.682,11.66c-3.203,2.644-11.315,7.093-27.682,11.66 c0.162-3.868,0.254-7.754,0.254-11.66S416.163,191.514,416.001,187.646z M437.711,166.814c-7-2.595-15.133-4.997-24.337-7.184 c-1.594-10.85-3.841-21.443-6.714-31.682C420.861,139.553,431.353,152.738,437.711,166.814z M348.299,69.587 c-10.239-2.872-20.831-5.119-31.682-6.714c-2.188-9.204-4.588-17.337-7.184-24.337C323.51,44.894,336.694,55.386,348.299,69.587z  M244.451,38.536c-2.595,7-4.997,15.133-7.184,24.337c-10.85,1.594-21.443,3.841-31.682,6.714 C217.19,55.386,230.374,44.894,244.451,38.536z M147.223,127.95c-2.872,10.239-5.119,20.831-6.714,31.682 c-9.204,2.187-17.337,4.588-24.337,7.184C122.531,152.738,133.023,139.553,147.223,127.95z M116.173,231.797 c7,2.595,15.133,4.997,24.337,7.183c1.594,10.85,3.841,21.443,6.714,31.682C133.023,259.059,122.531,245.873,116.173,231.797z  M205.585,329.024c10.239,2.872,20.831,5.119,31.682,6.713c2.188,9.204,4.588,17.337,7.184,24.337 C230.374,353.716,217.19,343.224,205.585,329.024z M309.433,360.075c2.595-7,4.997-15.133,7.184-24.337 c10.85-1.594,21.443-3.841,31.682-6.713C336.694,343.224,323.51,353.716,309.433,360.075z M406.661,270.662 c2.872-10.239,5.119-20.831,6.714-31.682c9.204-2.187,17.337-4.588,24.337-7.183C431.353,245.873,420.861,259.059,406.661,270.662z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.0891,
    y1: 439.7303,
    x2: 101.7791,
    y2: 456.2753,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98BC00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E6D03"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    points: "151.99,41.277 102.156,91.112 110.353,99.308 196.721,99.574 197.021,42.546 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.5287,
    y1: 75.4437,
    x2: 254.5287,
    y2: 59.5037,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 219.799,
    y: 426.145,
    style: {
      fill: "url(#SVGID_4_)"
    },
    width: 71.841,
    height: 29.082
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.5317,
    y1: 49.5137,
    x2: 254.5317,
    y2: 35.2937,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_5_)"
    },
    d: "M308.405,479.701H203.039c-4.167,0-7.545-3.378-7.545-7.545l0,0 c0-10.164,8.239-18.403,18.403-18.403h83.651c10.164,0,18.403,8.239,18.403,18.403l0,0 C315.95,476.322,312.572,479.701,308.405,479.701z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 254.5272,
    y1: 24.9237,
    x2: 254.5272,
    y2: 2.2837,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_6_)"
    },
    d: "M351.621,499.988c0,1.86-0.425,3.614-1.18,5.188c-0.584,1.233-1.382,2.349-2.339,3.306 c-1.956,1.957-4.582,3.243-7.505,3.477c-0.329,0.032-0.66,0.042-0.989,0.042H171.838c-6.645,0-12.024-5.379-12.024-12.013 c0-8.091,3.285-15.415,8.59-20.72s12.629-8.59,20.72-8.59h133.197C338.502,470.677,351.621,483.807,351.621,499.988z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.337,
    y1: 18.902,
    x2: 189.087,
    y2: 111.152,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2C7D8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#879FAF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_7_)"
    },
    d: "M350.441,505.175c-0.584,1.233-1.382,2.349-2.339,3.306c-1.956,1.957-4.582,3.243-7.505,3.477 H236.773l-41.281-41.281h120.462L350.441,505.175z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_8_",
    cx: 242.3487,
    cy: 356.7137,
    r: 218.58,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98BC00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    style: {
      stopColor: "#97BA00",
      stopOpacity: 0.472
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.641,
    style: {
      stopColor: "#92B300",
      stopOpacity: 0.641
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    style: {
      stopColor: "#89A801",
      stopOpacity: 0.762
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    style: {
      stopColor: "#7D9701",
      stopOpacity: 0.86
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.943,
    style: {
      stopColor: "#6D8102",
      stopOpacity: 0.943
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E6D03"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_8_)"
    },
    d: "M276.942,4.894c-12.08,0-23.9,1.111-35.37,3.22c57.992,13.135,101.291,64.982,101.291,126.946 c0,71.889-58.278,130.165-130.165,130.165c-61.964,0-113.811-43.299-126.946-101.291c-2.108,11.471-3.22,23.29-3.22,35.37 c0,107.37,87.041,194.412,194.412,194.412s194.412-87.041,194.412-194.412S384.312,4.894,276.942,4.894z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 42.1841,
    y1: 282.715,
    x2: 444.8341,
    y2: 266.775,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_9_)"
    },
    d: "M438.537,371.23c-92.352,92.352-242.62,92.352-334.971,0s-92.352-242.62,0-334.971 l18.484,18.484c-82.16,82.16-82.16,215.843,0,298.003s215.843,82.16,298.003,0L438.537,371.23z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.5643,
    y1: 447.1381,
    x2: 160.3043,
    y2: 507.8631,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_10_)"
    },
    points: "158.434,36.635 103.941,91.127 76.696,63.88 131.188,9.388 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 361.2545,
    y1: 251.5108,
    x2: 256.0145,
    y2: 343.7608,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2C7D8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#879FAF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_11_)"
    },
    points: "84.277,71.463 111.94,71.463 152.601,30.802 131.188,9.388 76.696,63.88 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 100.2328,
    y1: 481.1648,
    x2: 116.6028,
    y2: 464.7938,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_12_)"
    },
    d: "M136.47,19.7L87.007,69.163c-4.507,4.507-11.813,4.507-16.32,0l0,0 c-4.507-4.507-4.507-11.813,0-16.32L120.15,3.38c4.507-4.507,11.813-4.507,16.32,0l0,0C140.977,7.888,140.977,15.194,136.47,19.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.5524,
    y1: 453.8434,
    x2: 143.9224,
    y2: 437.4774,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_13_)"
    },
    d: "M163.897,47.128l-49.463,49.463c-4.507,4.507-11.813,4.507-16.32,0l0,0 c-4.507-4.507-4.507-11.813,0-16.32l49.463-49.463c4.507-4.507,11.813-4.507,16.32,0l0,0 C168.404,35.315,168.404,42.621,163.897,47.128z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.7755,
    y1: 137.927,
    x2: 469.5055,
    y2: 198.657,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_14_)"
    },
    points: "468.855,347.056 414.363,401.548 387.117,374.302 441.609,319.81 "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 517.1917,
    y1: 76.655,
    x2: 411.9516,
    y2: 168.905,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2C7D8",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#879FAF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_15_)"
    },
    points: "394.699,381.885 422.362,381.885 463.023,341.224 441.609,319.81 387.117,374.302  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 409.4412,
    y1: 171.9562,
    x2: 425.8112,
    y2: 155.5862,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_16_)"
    },
    d: "M446.892,330.121l-49.463,49.463c-4.507,4.507-11.813,4.507-16.32,0l0,0 c-4.507-4.507-4.507-11.813,0-16.32l49.463-49.463c4.507-4.507,11.813-4.507,16.32,0l0,0 C451.398,318.308,451.398,325.615,446.892,330.121z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 436.7607,
    y1: 144.6357,
    x2: 453.1307,
    y2: 128.2657,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E7F1FD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B2C7D8"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_17_)"
    },
    d: "M474.319,357.549l-49.463,49.463c-4.507,4.507-11.813,4.507-16.32,0l0,0 c-4.507-4.507-4.507-11.813,0-16.32l49.463-49.463c4.507-4.507,11.813-4.507,16.32,0l0,0 C478.826,345.736,478.826,353.043,474.319,357.549z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.684,272.204c-4.805-1.856-7.527-3.055-7.64-3.106l4.724-10.697 c0.026,0.011,2.612,1.149,7.128,2.894L175.684,272.204z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M281.984,293.651l-0.11-11.694c5.047-0.048,10-0.31,14.721-0.78l1.157,11.637 C292.684,293.318,287.38,293.6,281.984,293.651z M266.295,293.193c-5.047-0.331-10.28-0.847-15.554-1.534l1.51-11.596 c5.028,0.655,10.011,1.146,14.811,1.462L266.295,293.193z M313.462,290.414l-2.404-11.444c4.859-1.021,9.559-2.32,13.974-3.861 l3.856,11.04C324,287.855,318.809,289.291,313.462,290.414z M235.349,289.21c-4.99-0.933-10.106-2.022-15.207-3.237l2.71-11.375 c4.916,1.172,9.844,2.22,14.647,3.118L235.349,289.21z M205.124,282.036c-4.957-1.419-9.945-2.962-14.822-4.588l3.698-11.094 c4.719,1.573,9.545,3.067,14.341,4.44L205.124,282.036z M343.661,279.729l-5.471-10.335c4.249-2.249,8.284-4.834,12-7.685 l7.12,9.277C353.076,274.234,348.484,277.176,343.661,279.729z M369.281,260.019l-8.615-7.908 c3.161-3.443,6.098-7.236,8.725-11.274l9.8,6.382C376.212,251.794,372.877,256.102,369.281,260.019z M386.936,233.125 l-10.625-4.885c1.951-4.245,3.702-8.8,5.204-13.542l11.149,3.533C391.015,223.434,389.088,228.444,386.936,233.125z  M396.645,202.906l-11.452-2.375c0.963-4.639,1.757-9.535,2.361-14.554l11.611,1.398 C398.521,192.721,397.674,197.946,396.645,202.906z M400.48,171.783l-11.68-0.588c0.207-4.108,0.312-8.397,0.313-12.749 c0-0.717-0.003-1.439-0.008-2.164l11.695-0.082c0.005,0.753,0.008,1.502,0.008,2.248 C400.807,162.994,400.696,167.481,400.48,171.783z M388.611,141.322c-0.275-4.839-0.671-9.874-1.176-14.966l11.638-1.154 c0.52,5.256,0.929,10.456,1.213,15.456L388.611,141.322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M385.656,111.26c-0.347-2.562-0.725-5.161-1.128-7.794l11.559-1.773 c0.415,2.701,0.799,5.364,1.158,7.991L385.656,111.26z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 264.1512,
    y1: 194.3462,
    x2: 142.4912,
    y2: 315.9962,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98BC00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E6D03"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_18_)"
    },
    d: "M383.898,361.687c-30.682,20.242-67.444,32.032-106.96,32.032 c-6.836,0-13.576-0.35-20.231-1.042L148.96,284.93c-1.148-1.01-2.275-2.136-3.391-3.349l-0.032-0.032 c-4.443-4.89-8.536-11.322-12.161-18.498c0-0.011-0.011-0.021-0.021-0.042c-0.892-1.786-1.775-3.614-2.615-5.485 c-0.415-0.936-0.829-1.881-1.233-2.828c0-0.011-0.011-0.021-0.011-0.021c-0.797-1.881-1.563-3.785-2.297-5.698 c-0.021-0.053-0.042-0.106-0.063-0.16c-0.723-1.903-1.415-3.817-2.073-5.74c-0.011-0.032-0.021-0.053-0.021-0.085 c-0.319-0.936-0.637-1.871-0.936-2.807c-0.032-0.085-0.053-0.17-0.085-0.255c-0.595-1.85-1.159-3.699-1.68-5.539 c-0.032-0.106-0.064-0.202-0.095-0.308c-0.255-0.904-0.5-1.797-0.744-2.69c-0.021-0.074-0.042-0.149-0.064-0.223 c-0.223-0.871-0.447-1.733-0.659-2.594c-0.021-0.053-0.032-0.106-0.053-0.17c-0.139-0.553-0.266-1.095-0.394-1.637 c-0.074-0.308-0.149-0.616-0.223-0.925c-0.032-0.139-0.064-0.287-0.095-0.426c-0.192-0.85-0.382-1.691-0.553-2.52 c-0.011-0.032-0.011-0.053-0.021-0.074c-0.171-0.808-0.329-1.616-0.479-2.402c-0.032-0.128-0.053-0.255-0.085-0.394 c-0.149-0.776-0.287-1.552-0.415-2.318c-0.032-0.139-0.053-0.266-0.074-0.404c-0.117-0.734-0.245-1.467-0.351-2.18 c0-0.053-0.011-0.095-0.021-0.149c-0.106-0.744-0.213-1.467-0.298-2.18c-0.021-0.149-0.042-0.297-0.053-0.447 c-0.095-0.702-0.171-1.392-0.234-2.062c-0.011-0.085-0.021-0.17-0.032-0.266c-0.053-0.616-0.106-1.223-0.149-1.818 c-0.011-0.116-0.021-0.223-0.032-0.34c-0.042-0.627-0.074-1.244-0.095-1.839c-0.01-0.128-0.01-0.255-0.01-0.372 c-0.021-0.616-0.042-1.212-0.042-1.786c0-0.691,0.021-1.392,0.053-2.084c0.011-0.234,0.032-0.468,0.042-0.702 c0.032-0.468,0.064-0.925,0.106-1.382c0.021-0.266,0.042-0.531,0.074-0.787c0.063-0.627,0.139-1.244,0.234-1.86 c3.296-22.091,22.346-39.037,45.352-39.037c16.659,0,31.245,8.877,39.271,22.166l0.106-0.085l70.463,70.463L383.898,361.687z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.7887,
    y1: 290.8622,
    x2: 105.4287,
    y2: 290.8622,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4C4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF001C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_19_)"
    },
    d: "M208.79,203.872c0,25.328-20.532,87.235-45.86,87.235s-45.86-61.907-45.86-87.235 s20.532-45.86,45.86-45.86S208.79,178.544,208.79,203.872z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 154.0187,
    y1: 290.8622,
    x2: 179.3687,
    y2: 290.8622,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF4C4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF001C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_20_)"
    },
    d: "M206.374,204.961c0,23.994-19.451,82.641-43.445,82.641s-43.445-58.646-43.445-82.641 s19.451-43.445,43.445-43.445S206.374,180.968,206.374,204.961z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 211.2181,
    y1: 261.1432,
    x2: 141.5981,
    y2: 330.7632,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF001C",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#C1001C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_21_)"
    },
    d: "M208.721,206.494l-22.867-23.001c-5.732-6.119-13.879-9.947-22.925-9.947 c-17.35,0-31.416,14.065-31.416,31.416c0,8.965,3.762,17.047,9.785,22.77l45.313,45.577 C199.236,254.041,207.886,223.762,208.721,206.494z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_22_",
    cx: 142.3087,
    cy: 330.0338,
    r: 61.47,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCF42"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    style: {
      stopColor: "#FFCD3C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.258,
    style: {
      stopColor: "#FFC62A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.429,
    style: {
      stopColor: "#FFBA0D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.496,
    style: {
      stopColor: "#FFB500"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7000"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_22_)"
    },
    cx: 162.927,
    cy: 204.961,
    r: 31.413
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.8286,
    y1: 351.9037,
    x2: 361.1586,
    y2: 431.5706,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#98BC00",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5E6D03"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_23_)"
    },
    d: "M395.893,77.027l-7.389,7.389c-1.216,1.217-3.188,1.217-4.405,0l-0.554-0.554l-4.557-4.556 l0,0l-2.278-2.278c-1.217-1.217-3.188-1.217-4.405,0l-15.808,15.808c-1.217,1.217-1.217,3.188,0,4.405l7.388,7.389 c1.217,1.217,1.217,3.188,0,4.405l-7.388,7.389c-1.217,1.217-1.217,3.188,0,4.405l2.278,2.278l0,0L468.47,232.8 c1.89-10.883,2.884-22.072,2.884-33.495c0-21.308-3.439-41.811-9.774-60.996l-61.282-61.282 C399.081,75.811,397.109,75.811,395.893,77.027z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 378.8787,
    y1: 408.1307,
    x2: 400.0287,
    y2: 408.1307,
    gradientTransform: "matrix(1.0039 0 0 -1.0039 0.1922 516.5623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#456A97"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A338C"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_24_)"
    },
    d: "M395.893,77.027l-7.389,7.389c-1.217,1.217-3.188,1.217-4.405,0l-7.389-7.389 c-1.217-1.217-3.188-1.217-4.405,0l-15.808,15.808c-1.217,1.217-1.217,3.188,0,4.405l7.389,7.389c1.217,1.217,1.217,3.188,0,4.405 l-7.389,7.389c-1.217,1.217-1.217,3.188,0,4.405l15.808,15.808c1.217,1.217,3.188,1.217,4.405,0l7.389-7.389 c1.217-1.217,3.188-1.217,4.405,0l7.389,7.389c1.217,1.217,3.188,1.217,4.405,0l15.808-15.808c1.217-1.217,1.217-3.188,0-4.405 l-7.388-7.389c-1.217-1.217-1.217-3.188,0-4.405l7.389-7.389c1.217-1.217,1.217-3.188,0-4.405l-15.808-15.808 C399.081,75.811,397.108,75.811,395.893,77.027z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGlobe);
export default __webpack_public_path__ + "static/media/icon-globe.92a5b5547db86202e68707d4157994a0.svg";
export { ForwardRef as ReactComponent };